import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { toastr } from '@/utils/toast'
import moment from 'moment'

import { logOut } from '@/services/auth'

import { resetFormData } from '@/store/slices/formDataSlice'
import { setModal, unsetModal } from '@/store/slices/modalSlice'

import Logo from '@/components/Logo'

import config from '@/config/config-esm'

const STAND_DEPARTMENTS = [
  '6e8e995c-5070-4071-a487-09948a761d65', // Adicio
  '89139c3e-ae02-4473-9a3d-ceff542c92b7', // AB marketing
]

function nameStr(user: any) {
  return user.firstName ? (user.firstName + ' ' + (user.lastName || '')).trim() : user.email
}

const Header: React.FC = () => {
  const dispatch = useDispatch()
  const user = useSelector((state: any) => state.user)
  const layout = useSelector((state: any) => state.layout)

  const startStand = () => {
    const { departmentId } = layout.data
    axios
      .post(`${config.newApiUrl}/stand_instances`, { department_id: departmentId })
      .then((r) => {
        if (r.data.success) {
          dispatch(
            setModal({
              show: true,
              heading: 'Stand startet',
              body: (
                <p>
                  Stand startet av {nameStr(user.user)} kl. {moment().format('HH:mm')}.
                </p>
              ),
              button: (
                <button className="secondary large" onClick={() => dispatch(unsetModal())}>
                  OK
                </button>
              ),
            }),
          )
        }
      })
      .catch((e) => {
        toastr.error('Kunne ikke starte stand', `Vennligst prøv på nytt senere`)
      })
  }

  const emptyForm = () => {
    dispatch(resetFormData())
  }

  const standButtonVisible =
    layout.data &&
    layout.data.departmentId &&
    STAND_DEPARTMENTS.indexOf(layout.data.departmentId) !== -1

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Logo />
        <nav>
          {standButtonVisible && (
            <button className="stand" onClick={startStand}>
              Start stand
            </button>
          )}
          <button className="empty" onClick={() => emptyForm()}>
            Tøm skjema
          </button>
          <button className="logout" onClick={() => logOut(dispatch)}>
            Logg ut {nameStr(user.user)}
          </button>
        </nav>
      </div>
    </header>
  )
}

export default Header
